"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.combineMuteStatusWithAudioSourceInProgram = exports.attachAudioPresenterSources = exports.addUnChangedBannerLayerToProgram = exports.addAudioPresentersToProgramLayer = exports.UNASSIGNED = exports.EMPTY_THUMBNAIL = void 0;
exports.filteredScenesForUpdate = filteredScenesForUpdate;
exports.findAndUpdate = findAndUpdate;
exports.findAndUpdateEmptySourceTitle = findAndUpdateEmptySourceTitle;
exports.formatBannerMarkup = formatBannerMarkup;
exports.generateBanner = generateBanner;
exports.getMediaSourceValueObject = exports.getMediaSourceElement = exports.getMediaSettings = exports.getLiveCameraSources = exports.getIsStagedSourcesActive = exports.getElapsedTime = exports.getDefaultCameraSource = exports.getAudioSourceInProgram = exports.getActiveSourceForUser = void 0;
exports.getMinutesDifference = getMinutesDifference;
exports.getSourceFromResponse = exports.getSourceFromProgramLayers = exports.getSourceFirstNameLastName = exports.getSignedUrl = exports.getSceneLayout = exports.getProgramLayers = void 0;
exports.getSourceValue = getSourceValue;
exports.isItemValid = exports.isInitializing = exports.isImageSource = exports.isDuplicateRequest = exports.isDisconnected = exports.isDirectorRequest = exports.isCameraPresenter = exports.isAvailableSource = exports.isAudioVideoSource = exports.isAudioSource = exports.isAssignedPresenterSource = exports.hasSameAudioVideoSource = exports.groupById = exports.getUnassignedMediaSources = exports.getStreamSource = exports.getStartedOn = exports.getSourcesSignedUrl = exports.getSourceValueChanges = void 0;
exports.isLayout = isLayout;
exports.reValidateAudioPresentersInProgramLayers = exports.isVideoSource = exports.isUnassigned = exports.isSourceInProgram = exports.isScreenPresenter = exports.isPresenterSource = exports.isPendingKnock = exports.isPdfSource = exports.isObjectSourceValue = exports.isMediaSourceExcludeAudio = exports.isMediaSource = exports.isMediaOrPresenterSource = void 0;
exports.removeH2FromPresenterBannerMarkup = removeH2FromPresenterBannerMarkup;
exports.sanitizeHTML = exports.resetNotLiveVideoSource = void 0;
exports.sourcesWithPreviousDisconnectedState = sourcesWithPreviousDisconnectedState;
exports.withAttendeeCameraStatus = void 0;
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));
var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _typeof2 = _interopRequireDefault(require("@babel/runtime/helpers/typeof"));
var _underscore = require("underscore");
var _moment = _interopRequireDefault(require("moment"));
var _Banners = require("../../constants/Banners");
var _KnockTypes = require("../../constants/KnockTypes");
var _MediaPlayer = require("../../constants/MediaPlayer");
var _SceneLayouts = require("../../constants/SceneLayouts");
var _SourceItems = require("../../constants/SourceItems");
var _Tabs = require("../../constants/Tabs");
var _Timeout = require("../../constants/Timeout");
var _Sources = require("@studio/constants/Sources");
var _excluded = ["layer", "source"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
/** Check if layout is a valid layout */
function isLayout(layout, compare) {
  return (layout === null || layout === void 0 ? void 0 : layout.title) === (compare === null || compare === void 0 ? void 0 : compare.title) || (layout === null || layout === void 0 ? void 0 : layout.id) === (compare === null || compare === void 0 ? void 0 : compare.id);
}

/**
 * Get an object value even when the value is in "legacy" format for media sources (used to be just the event doc ID)
 * @param {*} value
 */
var getMediaSourceValueObject = exports.getMediaSourceValueObject = function getMediaSourceValueObject(value) {
  return typeof value === 'string' ? {
    eventDocId: value
  } : value;
};

/**
 * Gets the time difference in minutes given two timestamps
 * @param {number} startTime
 * @param {number} finishTime
 */
function getMinutesDifference(startTime, finishTime) {
  var difference = Math.abs(finishTime - startTime);
  return Math.floor(difference / 1000 / 60); // milliseconds / seconds
}

/** Check that the item is not undefined or null */
var isItemValid = exports.isItemValid = function isItemValid(item) {
  return !!item;
};

/**
 * Check if Audio Source
 */
var isAudioSource = exports.isAudioSource = function isAudioSource(source) {
  return source && source.type === _SourceItems.AUDIO_FILE;
};

/**
 * Check if Video Source
 */
var isVideoSource = exports.isVideoSource = function isVideoSource(source) {
  return source && source.type === _SourceItems.VIDEO_FILE;
};

/** Check if source is an image source */
var isImageSource = exports.isImageSource = function isImageSource(source) {
  return source && source.type === _SourceItems.IMAGE_FILE;
};

/**

  /** Check if source is a PDF source */
var isPdfSource = exports.isPdfSource = function isPdfSource(source) {
  return source && source.type === _SourceItems.PDF_FILE;
};

/**

   * Check if Camera presenter
   */
var isCameraPresenter = exports.isCameraPresenter = function isCameraPresenter(source) {
  return source && source.type === _SourceItems.CAMERA_PRESENTER;
};
var isScreenPresenter = exports.isScreenPresenter = function isScreenPresenter(source) {
  return source && source.type === _SourceItems.SCREEN_PRESENTER;
};
/**
 * Check if Media with an Audio source
 */
var isAudioVideoSource = exports.isAudioVideoSource = function isAudioVideoSource(source) {
  return [_SourceItems.VIDEO_FILE, _SourceItems.AUDIO_FILE].includes(source.type);
};

/**
 * CHeck if Media source
 */
var isMediaSource = exports.isMediaSource = function isMediaSource(source) {
  return [_SourceItems.VIDEO_FILE, _SourceItems.AUDIO_FILE, _SourceItems.IMAGE_FILE, _SourceItems.PDF_FILE, _Tabs.MEDIA].includes(source.type);
};
var isMediaSourceExcludeAudio = exports.isMediaSourceExcludeAudio = function isMediaSourceExcludeAudio(source) {
  return [_SourceItems.VIDEO_FILE, _SourceItems.IMAGE_FILE, _SourceItems.PDF_FILE, _Tabs.MEDIA].includes(source.type);
};
var UNASSIGNED = exports.UNASSIGNED = 'Unassigned';
var EMPTY_THUMBNAIL = exports.EMPTY_THUMBNAIL = 'EmptyThumbnail';

/**
 * Check if presenter source
 */
var isPresenterSource = exports.isPresenterSource = function isPresenterSource(source) {
  return [_SourceItems.CAMERA_PRESENTER, _SourceItems.SCREEN_PRESENTER].includes(source.type);
};
var isAssignedPresenterSource = exports.isAssignedPresenterSource = function isAssignedPresenterSource(source) {
  return isPresenterSource(source) && source.value !== UNASSIGNED;
};

/**
 * Check if source.value is type object
 */
var isObjectSourceValue = exports.isObjectSourceValue = function isObjectSourceValue(sourceValue) {
  return (0, _typeof2["default"])(sourceValue) === 'object';
};
var isMediaOrPresenterSource = exports.isMediaOrPresenterSource = function isMediaOrPresenterSource(source) {
  return isMediaSource(source) || isPresenterSource(source);
};
/**
 * Get Source Value changes
 */
var getSourceValueChanges = exports.getSourceValueChanges = function getSourceValueChanges(source, serverTimeDelta) {
  var sourceValue = source.value,
    hidden = source.hidden;
  if (isAudioVideoSource(source)) {
    var isPlaying = sourceValue.isPlaying && hidden ? true : !sourceValue.isPlaying;
    return _objectSpread(_objectSpread({}, sourceValue), {}, {
      seek: 0,
      // Some sources have isPlaying value already set to true
      isPlaying: isPlaying,
      startedOn: getStartedOn(isPlaying, serverTimeDelta)
    });
  }
  return sourceValue;
};
var getSourceFromProgramLayers = exports.getSourceFromProgramLayers = function getSourceFromProgramLayers(layers, predicate) {
  return layers === null || layers === void 0 ? void 0 : layers.map(function (layer) {
    return layer === null || layer === void 0 ? void 0 : layer.source;
  }).filter(predicate);
};
var getIsStagedSourcesActive = exports.getIsStagedSourcesActive = function getIsStagedSourcesActive(stagedSourcesMap) {
  return Object.keys(stagedSourcesMap).reduce(function (acc, sId) {
    return acc || stagedSourcesMap[sId];
  }, false);
};
var getMediaSourceElement = exports.getMediaSourceElement = function getMediaSourceElement(sourceId) {
  return document.getElementById("media_player_".concat(sourceId));
};
var getStartedOn = exports.getStartedOn = function getStartedOn(isPlaying) {
  var serverTimeDelta = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
  return isPlaying ? (0, _moment["default"])().utc().unix() - serverTimeDelta + _MediaPlayer.PLAY_DELAY : undefined;
};

/**
 * Reset unhidden video source to seek position 0
 *
 * @param liveSources
 * @param sources
 * @param dispatch
 * @param updateSource updateSource function
 * @returns {*}
 */
var resetNotLiveVideoSource = exports.resetNotLiveVideoSource = function resetNotLiveVideoSource(liveSources, sources, serverTimeDelta, dispatch, updateSource) {
  var sourceToUpdate = null;
  var resetSources = sources.map(function (source) {
    var _id = source._id,
      type = source.type,
      hidden = source.hidden;
    if (type === _SourceItems.VIDEO_FILE && !hidden && !liveSources.includes(_id)) {
      source.value = _objectSpread(_objectSpread({}, source.value), {}, {
        seek: 0,
        isPlaying: true,
        startedOn: getStartedOn(true, serverTimeDelta)
      });
      sourceToUpdate = source;
      return source;
    }
    return source;
  });
  if (sourceToUpdate) {
    var _sourceToUpdate = sourceToUpdate,
      _id = _sourceToUpdate._id,
      value = _sourceToUpdate.value;
    dispatch(updateSource(_id, {
      value: value
    }));
  }
  return resetSources;
};

/**
 * This function returns the social icon from RTMP url
 * @param {String} url to screen
 * @return {Object} returns the vendor name of the stream source
 */

var streamNames = ['facebook', 'vimeo', 'youtube', 'bcovelive', 'twitter', 'twitch', 'linkedin', 'wowza', 'streaming', 'play', 'stop', 'recording', 'inactiveStream', 'activeRecording', 'inactiveRecording'];
var getStreamSource = exports.getStreamSource = function getStreamSource(url) {
  if (!url) {
    return 'recordingEllipse';
  }
  var source = 'rtmp';
  if (url) {
    streamNames.forEach(function (name) {
      if (url.includes(name)) {
        source = name;
      }
    });
  }
  return source;
};

/**
 * This function returns difference in time from given date param with current date
 * @param {String} startedAt the start date in string
 * @return {Number} returns the difference from now and startedAt
 */
var getElapsedTime = exports.getElapsedTime = function getElapsedTime(startedAt) {
  var currentServerTime = (0, _moment["default"])(startedAt).valueOf();
  var currentLocalTime = (0, _moment["default"])().valueOf();
  var elapsedTime = currentLocalTime - currentServerTime;
  return elapsedTime;
};

/**
 * This function groups an array by _id attribute as key to object mapping
 * @param {String} array the start date in string
 * @return {Number} returns the difference from now and startedAt
 */
var groupById = exports.groupById = function groupById(array) {
  return array.reduce(function (accumulator, currentObject) {
    var _id = currentObject._id;
    accumulator[_id] = currentObject;
    return accumulator;
  }, {});
};
var isSourceInProgram = exports.isSourceInProgram = function isSourceInProgram() {
  var layers = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var sourceId = arguments.length > 1 ? arguments[1] : undefined;
  // Check if source exists in program layer
  var _layers$filter$filter = layers.filter(function (layer) {
      return isItemValid(layer);
    }).filter(function (layer) {
      var _layer$source;
      return (layer === null || layer === void 0 || (_layer$source = layer.source) === null || _layer$source === void 0 ? void 0 : _layer$source._id) === sourceId;
    }),
    _layers$filter$filter2 = (0, _slicedToArray2["default"])(_layers$filter$filter, 1),
    layerSource = _layers$filter$filter2[0];
  return !!layerSource;
};
var getAudioSourceInProgram = exports.getAudioSourceInProgram = function getAudioSourceInProgram() {
  var layers = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  // Check if audio source exists in program layer
  var audioSource = layers.find(function (layer) {
    return isAudioSource(layer.source);
  });
  return audioSource === null || audioSource === void 0 ? void 0 : audioSource.source;
};
var getUnassignedMediaSources = exports.getUnassignedMediaSources = function getUnassignedMediaSources(sources) {
  var unAssignedMediaSources = sources.filter(function (source) {
    return source.type === _Tabs.MEDIA && source.value === '';
  });
  return unAssignedMediaSources;
};

// we are creating and audioPresenter for each screenPresenter or cameraPresenter that is unmuted
var attachAudioPresenterSources = exports.attachAudioPresenterSources = function attachAudioPresenterSources(sources, attendeeMuteStatus) {
  var unMutedPresenters = sources && sources.filter(function (s) {
    var sourceValue = getSourceValue(s);
    return s && [_SourceItems.CAMERA_PRESENTER, _SourceItems.SCREEN_PRESENTER].includes(s.type) && s.value && !attendeeMuteStatus[sourceValue];
  }) || [];
  // This should make sure that duplicate audio presenter is not added to program
  var audioPresenterSources = [];
  unMutedPresenters.forEach(function (source) {
    var sourceValue = getSourceValue(source);
    var audioSourceIndex = sources.findIndex(function (s) {
      return s.value === source._id && s.type === _SourceItems.AUDIO_PRESENTER;
    });
    if (audioSourceIndex <= -1) {
      audioPresenterSources.push(_objectSpread(_objectSpread({}, source), {}, {
        _id: sourceValue,
        type: _SourceItems.AUDIO_PRESENTER,
        value: source._id
      }));
    }
  });
  return sources ? sources.concat(audioPresenterSources) : [];
};

/**
 * This will make sure all audio presenter source in program has
 * a matching source from either camera / screen presenter
 * @param {Object} layers takes a layers of a program to validate
 * @param {Object} sources from broadcast sources
 * @return {Object} returns an updated program object that has been validated
 */
var reValidateAudioPresentersInProgramLayers = exports.reValidateAudioPresentersInProgramLayers = function reValidateAudioPresentersInProgramLayers(layers, sources) {
  var presenters = sources.filter(function (s) {
    return [_SourceItems.CAMERA_PRESENTER, _SourceItems.SCREEN_PRESENTER].includes(s.type);
  });
  return layers.filter(function (layer) {
    return presenters.findIndex(function (presenter) {
      return layer.source.value === presenter.value;
    }) > -1 || ![_SourceItems.CAMERA_PRESENTER, _SourceItems.SCREEN_PRESENTER, _SourceItems.AUDIO_PRESENTER].includes(layer.source.type);
  });
};

/**
 * This will add audio sources to program for any unMuted presenter given the attendeeId
 * @param {Object} layers takes a layers of a program to validate
 * @param {Object} sources with audio presenter sources
 * @return {Object} returns an updated program object that has been validated
 */
var addAudioPresentersToProgramLayer = exports.addAudioPresentersToProgramLayer = function addAudioPresentersToProgramLayer(layers, sources) {
  var filterAudioPresenter = sources.filter(function (s) {
    return s && s.type === _SourceItems.AUDIO_PRESENTER;
  });
  var audioPresenterLayer = filterAudioPresenter.map(function (source) {
    return {
      _id: source._id,
      source: source,
      layer: {}
    };
  });
  layers = layers.concat(audioPresenterLayer);
  return layers;
};

/**
 * This is expected to retain the current banner in state.
 * @param {Object} withAudioPresenterLayer a just updated program object that has the audioPresenter validated
 * @param {Object} program current program in state
 * @return {Object} returns an updated program object that has the correct banner layer
 */

var addUnChangedBannerLayerToProgram = exports.addUnChangedBannerLayerToProgram = function addUnChangedBannerLayerToProgram(withAudioPresenterLayer, program) {
  return withAudioPresenterLayer.map(function (layer) {
    var source = layer.source;
    // Updates the withAudioPresenterLayer with the correct program layer
    if (source && (source === null || source === void 0 ? void 0 : source.type) === 'banner') {
      var programLayer = program === null || program === void 0 ? void 0 : program.layers.find(function (programLayer) {
        return (programLayer === null || programLayer === void 0 ? void 0 : programLayer.source._id) === source._id;
      });

      /** What happens if programLayer is undefined? */
      return programLayer || layer;
    }
    return layer;
  });
};

/**
 * @description This will generate mock banner given the banner template type
 * @param {string} templateType
 * @param {boolean} hidden
 */
function generateBanner(templateType) {
  var hidden = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  var banner = {
    layer: {},
    source: {
      hidden: hidden,
      value: {
        templateVars: {},
        templateType: templateType,
        markup: '<section><h1>Presenter name</h1><h2>Presenter title</h2></section>'
      }
    }
  };
  return banner;
}

/**
 * @description Sanitize html from string
 * @param {string} str
 * @returns String return sanitised string
 */
var sanitizeHTML = exports.sanitizeHTML = function sanitizeHTML(str) {
  if (!str) {
    return '';
  }
  return str.replace(/[^\w. ]/gi, function (c) {
    return '&#' + c.charCodeAt(0) + ';';
  });
};

/**
 * @description Formats presenter banner markup
 * @param {string} title
 * @param {string} description
 * @param {string} markup
 * @returns Object
 */
function formatBannerMarkup(title, description, markup, templateVars) {
  var bannerStyle = {
    height: '40px',
    position: 'absolute',
    bottom: '5px',
    left: '5px'
  };
  var titleStyle = {};
  var subTitleStyle = {
    paddingBottom: '6px'
  };
  var bannerMarkup = markup;
  // Replace title placeholder with actual presenter title
  bannerMarkup = bannerMarkup.replace(_Banners.BANNER_PLACEHOLDERS.title, sanitizeHTML(title));
  if (templateVars && templateVars.useAccentAsBackground && templateVars.ACCENT_COLOR) {
    // Replace background color for section
    bannerMarkup = bannerMarkup.replace(/background: #[a-fA-F0-9]+;/g, "background: ".concat(templateVars.ACCENT_COLOR, ";"));
  }
  if (description) {
    // Replace description placeholder with actual presenter description
    bannerMarkup = bannerMarkup.replace(_Banners.BANNER_PLACEHOLDERS.description, sanitizeHTML(description));
  } else {
    bannerStyle.height = '27px';
    titleStyle = {
      paddingTop: '5px'
    };
    /**
     * Remove H2 tag `Presenter title` since we don't
     * have source description to display here.
     */
    bannerMarkup = removeH2FromPresenterBannerMarkup(bannerMarkup);
  }
  return {
    bannerStyle: bannerStyle,
    bannerMarkup: bannerMarkup,
    titleStyle: titleStyle,
    subTitleStyle: subTitleStyle
  };
}

/**
 * @description Returns a source value. if the value is unassigned,
 * it returns a concatenated value with the source id
 * @param {Object} source
 * @returns String
 */
function getSourceValue(source) {
  var sourceValue = source.value;
  if (sourceValue === UNASSIGNED) {
    sourceValue = "".concat(UNASSIGNED, "-").concat(source._id);
  }
  return sourceValue;
}

/**
 * @description This passes every scene and returns an updated scenes array
 * trimmed enough with the valid structure for an api update call.
 * @param {Object} scenes
 * @returns Array
 */
function filteredScenesForUpdate(scenes) {
  return scenes.map(function (scene) {
    // remove duplicate source layers
    return (0, _underscore.pick)(_objectSpread(_objectSpread({}, scene), {}, {
      layers: scene.layers.map(function (l) {
        return _objectSpread(_objectSpread({}, l), {}, {
          source: (0, _underscore.pick)(l.source, ['_id', 'title', 'type', 'value', 'hidden', 'order', 'thumbnail', 'description'])
        });
      })
    }), ['_id', 'description', 'title', 'layers', 'style', 'thumbnail', 'layout']);
  });
}
/**
 * Returns the layout for the scene
 * @param {Object} scene
 * @return {{id: *, title: *}}
 */
var getSceneLayout = exports.getSceneLayout = function getSceneLayout(scene) {
  var sceneLayout = {
    id: scene.layout,
    title: scene.title
  };
  // Change featured layout to grid when no featured source exist to avoid assigning placeholder default
  var isFeatured = isLayout(sceneLayout, _SceneLayouts.FEATURED_SCREEN) || isLayout(sceneLayout, _SceneLayouts.FEATURED_MEDIA) || isLayout(sceneLayout, _SceneLayouts.FEATURED_PRESENTER);
  if (isFeatured) {
    var hasFeaturedSource = scene.layers.some(function (_ref) {
      var layer = _ref.layer,
        source = _ref.source;
      var isAFeaturedFile = [_SourceItems.IMAGE_FILE, _SourceItems.PDF_FILE, _SourceItems.VIDEO_FILE, _Tabs.MEDIA, _SourceItems.SCREEN_PRESENTER].includes(source.type);
      return isAFeaturedFile && (layer.isContent === undefined || layer.isContent === true);
    });
    if (!hasFeaturedSource) {
      sceneLayout = _SceneLayouts.GRID;
      scene.layout = sceneLayout.id;
      scene.title = sceneLayout.title;
    }
  }
  return sceneLayout;
};

/**
 * Use to determine if the current knock type is a duplicate
 * @param {*} knock
 * @param {*} receivedKnock
 * @returns boolean
 */
var isDuplicateRequest = exports.isDuplicateRequest = function isDuplicateRequest(knock, receivedKnock) {
  return knock.presenterId === receivedKnock.presenterId && knock.type === receivedKnock.type && (knock.status || receivedKnock.status) === _KnockTypes.PENDING;
};

/**
 * Retrieves the active source for a given user from the broadcast sources.
 *
 * @param {Array} broadcastSources - The array of broadcast sources.
 * @param {string} userId - The ID of the studio user.
 * @returns {Object|undefined} - The active source object for the user, or undefined if not found.
 */
var getActiveSourceForUser = exports.getActiveSourceForUser = function getActiveSourceForUser(broadcastSources, userId) {
  return broadcastSources === null || broadcastSources === void 0 ? void 0 : broadcastSources.sources.find(function (element) {
    return (element === null || element === void 0 ? void 0 : element.user) === userId && (element === null || element === void 0 ? void 0 : element.value) !== 'Unassigned' && !(element !== null && element !== void 0 && element.isInitializing);
  });
};

/**
 * Util function to check if a knock status is pending
 * @param {*} kn
 * @returns boolean
 */
var isPendingKnock = exports.isPendingKnock = function isPendingKnock(kn) {
  return kn.status === _KnockTypes.PENDING;
};

/**
 * Check if knock is a director request type
 * Director request is one of microphone/canUnmute, screenshare/canScreenShare, camera/canToggleCamera,
 * @param {*} requestType
 * @returns boolean
 */
var isDirectorRequest = exports.isDirectorRequest = function isDirectorRequest(requestType) {
  return [_KnockTypes.MICROPHONE, _KnockTypes.SCREENSHARE, _KnockTypes.CAMERA].includes(requestType);
};

/**
 * @description Get camera sources from program layers
 * @param {[]} layers
 * @returns []
 */
var getLiveCameraSources = exports.getLiveCameraSources = function getLiveCameraSources(layers) {
  return layers.filter(function (_ref2) {
    var source = _ref2.source;
    return source.type === _SourceItems.CAMERA_PRESENTER && source.value !== UNASSIGNED;
  });
};

/**
 * Knock request unassigned presenter filters
 */
var isUnassigned = exports.isUnassigned = function isUnassigned(source) {
  return source.value === UNASSIGNED;
};

/**
 * Knock request unassigned presenter filters
 */
var isInitializing = exports.isInitializing = function isInitializing(source) {
  return source.isInitializing === true;
};

/** Predicate to check that the source is unassigned and disconnected */
var isDisconnected = exports.isDisconnected = function isDisconnected(source) {
  return source.value !== UNASSIGNED && source.disconnected;
};

/** Checks that the source is assigned and not in the attendee tile state */
var isAvailableSource = exports.isAvailableSource = function isAvailableSource(source, attendeeIds) {
  return source.value !== UNASSIGNED && !attendeeIds.includes(source.value);
};

/**
 * @param {Array} sourceLayers The source layers
 * @param {Array} destinationLayers The destination layers
 * @return {Boolean}
 */
var hasSameAudioVideoSource = exports.hasSameAudioVideoSource = function hasSameAudioVideoSource(sourceLayers) {
  var _sourceLayer$source, _destinationLayer$sou;
  var destinationLayers = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  var sourceLayer = sourceLayers === null || sourceLayers === void 0 ? void 0 : sourceLayers.find(function (_ref3) {
    var source = _ref3.source;
    return isAudioVideoSource(source);
  });
  var destinationLayer = destinationLayers.filter(function (layer) {
    return isItemValid(layer);
  }).find(function (_ref4) {
    var source = _ref4.source;
    return isAudioVideoSource(source);
  });
  return sourceLayer && destinationLayer && (sourceLayer === null || sourceLayer === void 0 || (_sourceLayer$source = sourceLayer.source) === null || _sourceLayer$source === void 0 ? void 0 : _sourceLayer$source._id) === (destinationLayer === null || destinationLayer === void 0 || (_destinationLayer$sou = destinationLayer.source) === null || _destinationLayer$sou === void 0 ? void 0 : _destinationLayer$sou._id);
};

/**
    @description Removes `<H2/>` from presenter banner markup
    @param {string} markup
   */
function removeH2FromPresenterBannerMarkup(markup) {
  var removeH2 = /<h2[^>]*>[^</]*<\/h2>/gi;
  return markup === null || markup === void 0 ? void 0 : markup.replace(removeH2, '');
}
var sourcesSignedUrlCache = {
  lastUpdated: new Date().getTime()
};

/**
    Returns a single source with signed url
    @param {{}} source
    @param {{}} apiClient
    @param {{}} forceFetch - Force fetch the signed URL by skipping cache
    @returns {{}} source with signed url.
   */
var getSignedUrl = exports.getSignedUrl = /*#__PURE__*/function () {
  var _ref5 = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee(source, apiClient) {
    var _source$value;
    var forceFetch,
      value,
      eventDocId,
      signedUrl,
      _yield$apiClient$even,
      url,
      _args = arguments;
    return _regenerator["default"].wrap(function (_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          forceFetch = _args.length > 2 && _args[2] !== undefined ? _args[2] : false;
          if (!(!(source !== null && source !== void 0 && source.value) || isPresenterSource(source) || (source === null || source === void 0 || (_source$value = source.value) === null || _source$value === void 0 ? void 0 : _source$value.type) === _Sources.STOCK_MEDIA)) {
            _context.next = 1;
            break;
          }
          return _context.abrupt("return", source);
        case 1:
          value = getMediaSourceValueObject(source.value);
          eventDocId = value.eventDocId;
          signedUrl = sourcesSignedUrlCache[eventDocId];
          if (!((!signedUrl || forceFetch) && source.team && source.event)) {
            _context.next = 3;
            break;
          }
          _context.next = 2;
          return apiClient.eventDoc.getSignedUrl(source.team, source.event, eventDocId);
        case 2:
          _yield$apiClient$even = _context.sent;
          url = _yield$apiClient$even.url;
          signedUrl = url;
          sourcesSignedUrlCache[eventDocId] = url;
        case 3:
          return _context.abrupt("return", _objectSpread(_objectSpread({}, source), {}, {
            value: _objectSpread(_objectSpread({}, value), {}, {
              url: signedUrl
            })
          }));
        case 4:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return function getSignedUrl(_x, _x2) {
    return _ref5.apply(this, arguments);
  };
}();

/**
    Maps a list of sources to signed urls
    @param {[]} sources
    @param {{}} apiClient
    @param {string} teamId
    @param {string} eventId
   */
var getSourcesSignedUrl = exports.getSourcesSignedUrl = /*#__PURE__*/function () {
  var _ref6 = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee2(sources, apiClient, teamId, eventId) {
    var minutes, isValidCache, eventDocIds, _yield$apiClient$even2, urls, sourcesWithSignedUrls;
    return _regenerator["default"].wrap(function (_context2) {
      while (1) switch (_context2.prev = _context2.next) {
        case 0:
          minutes = getMinutesDifference(sourcesSignedUrlCache.lastUpdated, new Date().getTime());
          isValidCache = minutes < _Timeout.SIGNED_URLS_CACHE_TIMEOUT_VALUE;
          eventDocIds = sources === null || sources === void 0 ? void 0 : sources.reduce(function (accumulator, source) {
            var value = source.value,
              type = source.type;
            if (!_SourceItems.S3SourceTypes.includes(type)) {
              return accumulator;
            }
            var _getMediaSourceValueO = getMediaSourceValueObject(value),
              eventDocId = _getMediaSourceValueO.eventDocId;
            if (!eventDocId || (value === null || value === void 0 ? void 0 : value.type) === _Sources.STOCK_MEDIA) {
              return accumulator;
            }
            var signedUrl = sourcesSignedUrlCache[eventDocId];
            if (signedUrl && isValidCache) {
              return accumulator;
            }
            accumulator.push(eventDocId);
            return accumulator;
          }, []);
          if (!(eventDocIds !== null && eventDocIds !== void 0 && eventDocIds.length)) {
            _context2.next = 2;
            break;
          }
          _context2.next = 1;
          return apiClient.eventDoc.getSignedUrls(teamId, eventId, {
            eventDocs: eventDocIds
          });
        case 1:
          _yield$apiClient$even2 = _context2.sent;
          urls = _yield$apiClient$even2.urls;
          // update sourcesSignedUrlCache including last updated timestamp.
          sourcesSignedUrlCache = _objectSpread(_objectSpread(_objectSpread({}, sourcesSignedUrlCache), urls), {}, {
            lastUpdated: new Date().getTime()
          });
        case 2:
          sourcesWithSignedUrls = sources === null || sources === void 0 ? void 0 : sources.map(function (source) {
            var value = source.value,
              type = source.type;
            if (!_SourceItems.S3SourceTypes.includes(type)) {
              return source;
            }

            // Convert to source object for legacy media files which has value as string
            var valueObj = getMediaSourceValueObject(value);
            var eventDocId = valueObj.eventDocId;
            if (!eventDocId || (value === null || value === void 0 ? void 0 : value.type) === _Sources.STOCK_MEDIA) {
              return source;
            }
            var signedUrl = sourcesSignedUrlCache[eventDocId];
            return _objectSpread(_objectSpread({}, source), {}, {
              value: _objectSpread(_objectSpread({}, valueObj), {}, {
                url: signedUrl
              })
            });
          });
          return _context2.abrupt("return", sourcesWithSignedUrls);
        case 3:
        case "end":
          return _context2.stop();
      }
    }, _callee2);
  }));
  return function getSourcesSignedUrl(_x3, _x4, _x5, _x6) {
    return _ref6.apply(this, arguments);
  };
}();
var isFulfilled = function isFulfilled(status) {
  return status === 'fulfilled';
};

/**
    @param {[]} response
   */
var getSourceFromResponse = exports.getSourceFromResponse = function getSourceFromResponse(response) {
  return response.reduce(function (memo, item) {
    var status = item.status,
      value = item.value;
    return isFulfilled(status) ? [].concat((0, _toConsumableArray2["default"])(memo), [value]) : memo;
  }, []);
};

/**
 * Gets the layers in a scene or program
 * @param {*} program scene/program
 * @returns Layer[] Array of layers
 */
var getProgramLayers = exports.getProgramLayers = function getProgramLayers(program) {
  var layers = (program === null || program === void 0 ? void 0 : program.layers) || [];
  return layers === null || layers === void 0 ? void 0 : layers.filter(function (layer) {
    return isItemValid(layer);
  });
};
var withAttendeeCameraStatus = exports.withAttendeeCameraStatus = function withAttendeeCameraStatus(program) {
  var attendeeCameraStatus = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var currentLayers = getProgramLayers(program).map(function (_ref7) {
    var layer = _ref7.layer,
      source = _ref7.source,
      rest = (0, _objectWithoutProperties2["default"])(_ref7, _excluded);
    var currentLayer = _objectSpread({
      source: source,
      layer: layer
    }, rest);
    if (isPresenterSource(source) && typeof attendeeCameraStatus[source.value] === 'boolean') {
      return _objectSpread(_objectSpread({}, currentLayer), {}, {
        layer: _objectSpread(_objectSpread({}, layer), {}, {
          isCameraOn: attendeeCameraStatus[source.value]
        })
      });
    }
    return currentLayer;
  });
  return _objectSpread(_objectSpread({}, program), {}, {
    layers: currentLayers
  });
};

/** Reducer util function to find and update broadcast sources
 *
 * Implementation update is to take account of the order of sources in the array
 * as it will have a direct impact on the program when sources are reordered.
 * */
function findAndUpdate(oldSources, updatedSources) {
  return (0, _toConsumableArray2["default"])(oldSources).reduce(function (a, c) {
    var updatedSource = (0, _underscore.find)(updatedSources, function (us) {
      return us._id === c._id;
    });
    if (!updatedSource) {
      a.push(c);
    }
    return a;
  }, (0, _toConsumableArray2["default"])(updatedSources));
}

/** Reducer util function to find sources with disconnected state
 *
 * Implementation update is to take account of the order of sources in the array
 * as it will have a direct impact on the program when sources are reordered.
 * */
function sourcesWithPreviousDisconnectedState(newSources, oldSources) {
  return (0, _toConsumableArray2["default"])(newSources).reduce(function (a, s) {
    var oldIndex = (0, _underscore.findIndex)(oldSources, function (oldSource) {
      return oldSource._id === s._id;
    });
    if (oldIndex > -1) {
      a[oldIndex] = _objectSpread(_objectSpread({}, s), {}, {
        disconnected: oldSources[oldIndex].disconnected,
        isInitializing: oldSources[oldIndex].isInitializing || false
      });
    } else {
      a.push(s);
    }
    return a;
  }, []).filter(function (s) {
    return !!s;
  });
}
/*
    This function sets the title of sources without titles to an empty string
  */
function findAndUpdateEmptySourceTitle(sources) {
  return sources.map(function (s) {
    if (!s.title) {
      s.title = '';
    }
    return s;
  });
}

/**
 * This will extend the attendeeMuteStatus object from store with sources
 * mute status in program
 */
var combineMuteStatusWithAudioSourceInProgram = exports.combineMuteStatusWithAudioSourceInProgram = function combineMuteStatusWithAudioSourceInProgram(sources, program, attendeeMuteStatus) {
  var extendedAttendeeMuteStatus = program.layers.reduce(function (muteStatue, _ref8) {
    var source = _ref8.source;
    if (source.value === UNASSIGNED && source.type === _SourceItems.CAMERA_PRESENTER) {
      var sourceValue = getSourceValue(source);
      var hasSource = isSourceInProgram(program.layers, sourceValue);
      if (hasSource) {
        muteStatue[sourceValue] = false;
      }
    }
    return muteStatue;
  }, _objectSpread({}, attendeeMuteStatus));
  extendedAttendeeMuteStatus = sources.reduce(function (muteStatue, source) {
    if (source.type === _SourceItems.CAMERA_PRESENTER) {
      var sourceValue = getSourceValue(source);
      if (extendedAttendeeMuteStatus[sourceValue] === undefined) {
        extendedAttendeeMuteStatus[sourceValue] = true;
      }
    }
    return muteStatue;
  }, extendedAttendeeMuteStatus);
  return extendedAttendeeMuteStatus;
};

/**
 * This returns the media settings for media control
 *
 * @param {Array} layers program or scene layers
 * @param {Boolean} isNotMinimized defaults to true
 * @param defaultSettings
 * @returns {{videoSettings: {value: {}}, audioSettings: {value: {}}, controllerStyles: {audio: string, video: string}}}
 */
var getMediaSettings = exports.getMediaSettings = function getMediaSettings(layers) {
  var isNotMinimized = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
  var defaultSettings = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var videoSourceLayer = layers.find(function (_ref9) {
    var source = _ref9.source;
    return isVideoSource(source);
  });
  var audioSourceLayer = layers.find(function (_ref0) {
    var source = _ref0.source;
    return isAudioSource(source);
  });
  var defaultValue = {
    value: {}
  };
  var video = (videoSourceLayer === null || videoSourceLayer === void 0 ? void 0 : videoSourceLayer.source) || defaultValue;
  var audio = (audioSourceLayer === null || audioSourceLayer === void 0 ? void 0 : audioSourceLayer.source) || defaultValue;
  var videoSettings = _objectSpread(_objectSpread({}, video), {}, {
    value: _objectSpread(_objectSpread({}, defaultSettings), video.value)
  });
  var audioSettings = _objectSpread(_objectSpread({}, audio), {}, {
    value: _objectSpread(_objectSpread({}, defaultSettings), audio.value)
  });
  var controllerStyles = {
    audio: '',
    video: ''
  };
  var noTopBorderRadiusStyle = "border-top-left-radius: unset; border-top-right-radius: unset;";
  var videoSolo = videoSettings._id && !audioSettings._id;
  var audioSolo = !videoSettings._id && audioSettings._id;
  var audioVideo = !!videoSettings._id && !!audioSettings._id;
  if (isNotMinimized) {
    if (audioVideo || videoSolo) {
      controllerStyles.video = noTopBorderRadiusStyle;
    } else if (audioSolo) {
      controllerStyles.audio = noTopBorderRadiusStyle;
    }
  }
  return {
    audioSettings: audioSettings,
    videoSettings: videoSettings,
    controllerStyles: controllerStyles
  };
};

/**
 * This returns the firstName and lastName from source title
 *
 * @param {string} title source title
 * @returns {{firstName: string, lastName: string}}
 */
var getSourceFirstNameLastName = exports.getSourceFirstNameLastName = function getSourceFirstNameLastName(title) {
  if (!title) {
    return {
      firstName: '',
      lastName: ''
    };
  }
  var words = title.split(' ');
  var firstName = words[0];
  var lastName = words.length > 1 ? words[words.length - 1] : '';
  return {
    firstName: firstName,
    lastName: lastName
  };
};

/**
 * This returns the a source that matches the name given so users can rejoin into existing placeholders
 *
 * @param {object} sources a list of sources available to be joined into
 * @param {string} name camera source name
 * @returns {object} the source that can be joined into that matches on the criteria
 */
var getDefaultCameraSource = exports.getDefaultCameraSource = function getDefaultCameraSource(sources, name) {
  var _defaultSource;
  // remove casing and white space to prevent odd mismatches
  var cameraName = name === null || name === void 0 ? void 0 : name.toLowerCase().replace(/\s+/g, '');
  var defaultSource;
  defaultSource = sources === null || sources === void 0 ? void 0 : sources.find(function (source) {
    var _source$title;
    return (source === null || source === void 0 || (_source$title = source.title) === null || _source$title === void 0 ? void 0 : _source$title.toLowerCase().replace(/\s+/g, '')) === cameraName;
  });
  console.log("getDefaultCameraSource - ".concat((_defaultSource = defaultSource) === null || _defaultSource === void 0 ? void 0 : _defaultSource.title, " for ").concat(name));

  // returns undefined if there's no match
  return defaultSource;
};